import { render } from "./SaveIcon.vue?vue&type=template&id=391962e2&scoped=true"
import script from "./SaveIcon.vue?vue&type=script&lang=js"
export * from "./SaveIcon.vue?vue&type=script&lang=js"

import "./SaveIcon.vue?vue&type=style&index=0&id=391962e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391962e2"]])

export default __exports__